import type * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "../../lib/cn";

export type AvatarProps = React.ComponentProps<typeof AvatarPrimitive.Root>;
export type AvatarImageProps = React.ComponentProps<
  typeof AvatarPrimitive.Image
>;
export type AvatarFallbackProps = React.ComponentProps<
  typeof AvatarPrimitive.Fallback
>;

export function Avatar({ className, ...props }: AvatarProps) {
  return (
    <AvatarPrimitive.Root
      className={cn(
        "relative flex size-10 shrink-0 overflow-hidden rounded-3xl",
        className,
      )}
      {...props}
    />
  );
}

export function AvatarImage({ className, ...props }: AvatarImageProps) {
  return (
    <AvatarPrimitive.Image
      className={cn("aspect-square size-full animate-in fade-in-0 duration-200", className)}
      {...props}
    />
  );
}

export function AvatarFallback({ className, ...props }: AvatarFallbackProps) {
  return (
    <AvatarPrimitive.Fallback
      className={cn(
        "flex size-full items-center justify-center rounded-3xl bg-avatar-no-image-background text-body-s-b text-text-placeholder animate-in fade-in-0 duration-200",
        className,
      )}
      {...props}
    />
  );
}
